import React from 'react';
import {
  useReactTable,
  getCoreRowModel,
  flexRender,
  createColumnHelper,
} from '@tanstack/react-table';

const columnHelper = createColumnHelper();

const columns = [
  columnHelper.accessor(row => row?.[0], {
    id: 'lob',
    header: 'LOB',
    cell: info => info.getValue() ?? '',
  }),
  columnHelper.accessor(row => row?.[1], {
    id: 'ppl',
    header: 'PPL',
    cell: info => info.getValue() ?? '',
  }),
  columnHelper.accessor(row => row?.[2], {
    id: 'pl',
    header: 'PL',
    cell: info => info.getValue() ?? '',
  }),
  columnHelper.accessor(row => row?.[3], {
    id: 'yearsGroup',
    header: 'Years Group',
    cell: info => info.getValue() ?? '',
  }),
  columnHelper.accessor(row => row?.[4], {
    id: 'numOfVehicles',
    header: '# of Vehicles',
    cell: info => info.getValue() ?? '',
  }),
  columnHelper.accessor(row => row?.[5], {
    id: 'avgKmRun',
    header: 'Avg KM Run',
    cell: info => info.getValue() ?? '',
  }),
  columnHelper.accessor(row => row?.[6], {
    id: 'avgHours',
    header: 'Avg Hrs',
    cell: info => info.getValue() ?? '',
  }),
];

const TableComponent = ({ data }) => {
  const table = useReactTable({
    data: data ?? [],
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="overflow-x-auto border rounded">
      <div className="max-h-[350px] overflow-y-auto">
        <table className="min-w-max w-full border text-sm">
          <thead className="bg-gray-100 sticky top-0 z-10">
            {table.getHeaderGroups().map(headerGroup => (
              <tr key={headerGroup.id}>
                {headerGroup.headers.map(header => (
                  <th
                    key={header.id}
                    className="border px-3 py-2 text-left font-medium bg-gray-300 whitespace-nowrap"
                  >
                    {flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody>
            {table.getRowModel().rows.map((row, rowIndex) => (
              <tr key={row.id} className={rowIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                {row.getVisibleCells().map(cell => (
                  <td
                    key={cell.id}
                    className="border px-3 py-2 whitespace-nowrap text-left"
                  >
                    {flexRender(cell.column.columnDef.cell, cell.getContext())}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TableComponent;
